export const WordpressAlignWide = ({className, children}) => (
    <main
        className={`wp-block-group has-global-padding is-layout-constrained wp-block-group-is-layout-constrained ${className ?? ''}`}>
        <div className="wp-block-group alignwide is-layout-flow wp-block-group-is-layout-flow">
            {children}
        </div>
    </main>
);